<script lang="ts">
  import type { StatuteBill, BankMatch, EasyJetPlusAnswer } from "../types";
  import Check from "~icons/ph/check-bold";
  import FooterButtons from "../../../components/workflow/FooterButtons.svelte";
  import StatuteBillSummary from "../elements/StatuteBillSummary.svelte";
  import BankAccountInfo from "../../Settlement/elements/BankAccountInfo.svelte";
  import Faqs from "../faqs/Faqs.svelte";
  import DownloadLink from "../../Settlement/elements/DownloadLink.svelte";
  import CloseButton from "../../../components/CloseButton.svelte";
  import EasyJetPlusNote from "../elements/EasyJetPlusNote.svelte";

  let {
    payoutAmount,
    statuteBill,
    bankMatch,
    reopened,
    easyJetPlusUrl,
    easyJetPlusAnswer,
  }: {
    payoutAmount: number;
    statuteBill: StatuteBill;
    bankMatch: BankMatch;
    reopened: boolean;
    easyJetPlusUrl?: string;
    easyJetPlusAnswer: EasyJetPlusAnswer;
  } = $props();
</script>

<div class="relative isolate">
  {#if reopened}
    <h2 class="ui-title">Your payment is on the way</h2>
  {:else}
    <div
      class="pointer-events-none absolute -z-10 -m-4 inset-x-0 top-0 h-[313px] bg-gradient-to-b from-sky-200/40"
      aria-hidden="true">
    </div>

    <div class="flex justify-center py-6">
      <div class="bg-white w-16 h-16 rounded-full flex items-center justify-center shadow">
        <Check class="text-emerald-500 w-11 h-11" />
      </div>
    </div>

    <h2 class="ui-title">You should receive payment within a week!</h2>
  {/if}
  <p>You’ll receive an email from us in the next few days, and your payment should appear in your bank account soon after.</p>

  <EasyJetPlusNote url={easyJetPlusUrl} status={easyJetPlusAnswer} />

  <StatuteBillSummary {statuteBill} {payoutAmount} class="mb-4" />

  <DownloadLink label="Download statute bill" href={statuteBill.download} class="mb-6" />

  <BankAccountInfo {bankMatch} showHeader={true} />

  <h3 class="ui-section-title">Have questions?</h3>
  <Faqs />

  <FooterButtons back={false}>
    {#if easyJetPlusAnswer === "claimed" || !easyJetPlusUrl}
      <CloseButton class="btn-primary w-full" />
    {:else}
      <CloseButton />
      <a href={easyJetPlusUrl} class="btn btn-primary" data-turbo-frame="task-modal">Claim year of easyJet Plus</a>
    {/if}
  </FooterButtons>
</div>
